import { hierarchy, pack } from "d3";
import { settleMarketSquares } from "./marketSquareLayout";

const cache = new WeakMap();

export function steamMarketDimensions(width, viewportHeight, top) {
  return { width, height: Math.max(0, viewportHeight - top - 72) };
}

export function getSteamMarketLayout(games, width, height, colorScale, shape) {
  if (!games.length || width <= 0 || height <= 72) return [];
  let entries = cache.get(games);
  if (!entries) {
    entries = new Map();
    cache.set(games, entries);
  }
  const key = `${width}:${height}`;
  let entry = entries.get(key);
  if (!entry || entry.colorScale !== colorScale) {
    const inset = Math.floor(Math.min(width, height) * .06);
    const side = Math.max(1, Math.min(width, height) - inset * 2);
    const children = games.filter(game => game.ccu > 0).map(game => ({
      ...game, value: game.ccu, color: colorScale(game.ccu),
    }));
    const root = hierarchy({ children }).sum(node => node.value);
    pack().size([side, side]).padding(1.5)(root);
    const circles = children.length ? root.leaves().map(node => ({
      x: node.x + Math.floor((width - side) / 2),
      y: node.y + Math.floor((height - side) / 2),
      r: node.r,
      data: node.data,
    })) : [];
    entry = { colorScale, circles };
    if (entries.size >= 4) entries.delete(entries.keys().next().value);
    entries.set(key, entry);
  }
  if (shape !== "squares") return entry.circles;
  if (!entry.squares) entry.squares = settleMarketSquares(entry.circles, width, height);
  return entry.squares;
}
